/* eslint-disable */
import { FormEditFieldCreateDialogView, FormEditFieldDialogViewFactory, FormEditFieldUpdateDialogView, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import {
  FormEditCreateUpdateStockSummaryFieldDialogComponent
} from "../../admin/form/form-edit/dialogs/fields/stock-summary/create-update/form-edit-create-update-stock-summary-field-dialog.component";
/* eslint-disable */
/* eslint-enable */

/* eslint-enable */

/**
 * ReadonlyText field implementation.
 */
export class FormEditStockSummaryFieldDialogViewFactory implements FormEditFieldDialogViewFactory {

  constructor(private injector: Injector,
              private cfr: ComponentFactoryResolver) {
  }

  createCreateView(): ComponentRef<FormEditFieldCreateDialogView> {
    return this.createView();
  }

  createUpdateView(): ComponentRef<FormEditFieldUpdateDialogView> {
    return this.createView();
  }

  private createView(): ComponentRef<FormEditCreateUpdateStockSummaryFieldDialogComponent> {
    return this.cfr.resolveComponentFactory(FormEditCreateUpdateStockSummaryFieldDialogComponent)
      .create(this.injector);
  }

}
